export class ViewableByData {
    constructor(data: ViewableByData) {
        this.showClients = data.showClients;
        this.showSubs = data.showSubs;
        this.showInternals = data.showInternals;
        this.isPrivate = data.isPrivate;
        this.isPrivateEnabled = data.isPrivateEnabled;
    }
    showInternals: boolean;
    showSubs: boolean;
    showClients: boolean;
    isPrivate: boolean;
    isPrivateEnabled: boolean;
}
